import { S3Client } from '@aws-sdk/client-s3';
import { t } from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { ReactComponent as Access } from '../../../assets/img/storage/actions-access.svg';
import { ReactComponent as Copy } from '../../../assets/img/storage/actions-copy.svg';
import { ReactComponent as Download } from '../../../assets/img/storage/actions-dl.svg';
import { ReactComponent as More } from '../../../assets/img/storage/actions-more.svg';
import { ReactComponent as Move } from '../../../assets/img/storage/actions-move.svg';
import { ReactComponent as Remove } from '../../../assets/img/storage/actions-remove.svg';
import { ReactComponent as Rename } from '../../../assets/img/storage/actions-rename.svg';
import { ReactComponent as Share } from '../../../assets/img/storage/actions-share.svg';
import { ReactComponent as Extract } from '../../../assets/svg/ExtractAndStay.svg';
import { ReactComponent as TransCode } from '../../../assets/svg/Tools.svg';
import Button from '../../../components/mplat/Button/Button';
import Label from '../../../components/mplat/Label';
import { BaseModalProps, Modal } from '../../../components/mplat/Modal';
import Select from '../../../components/mplat/Select';
import TextInput from '../../../components/mplat/TextInput';
import { ReactComponent as CloseIcon } from '../../../img/storage/actions-close.svg';
import { useCreateTranscodeTaskMutation } from '../../../services/transcode';
import { getBasename, s3dirname, StorageFolderSelection } from './StorageMy';

interface TranscodeModalProps extends BaseModalProps {
    prefix: string,
    client: S3Client,
    bucketname: string,
}

export function TranscodeModal({ isOpen, onClose, client, bucketname, prefix }: TranscodeModalProps) {
    const [createTranscode] = useCreateTranscodeTaskMutation();
    const [success, setSuccess] = useState<boolean>();
    const [fail, setFail] = useState<string>();
    const [profileId, setProfileId] = useState(1);
    const [path, setPath] = useState(s3dirname(prefix) );
    const [filename, setFilename] = useState(getBasename(prefix) + '.transcoded');
    const [isOpenFolderSelection, setIsOpenFolderSelection] = useState(false);

    const successClass = 'popup_message';

    const availProfiles = useMemo(() => {
        return [
            { value: 1, label: 'Профиль 1' },
            { value: 2, label: 'Профиль 2' },
            { value: 3, label: 'Профиль 3' },
            { value: 4, label: 'Профиль 4' },
        ]
    }, []);

    useEffect(() => {
        if (isOpen) {
            setSuccess(false);
        }
    }, [isOpen]);

    return (
        <Modal className={success ? successClass : 'form-opinion'} isOpen={isOpen} onClose={() => onClose()}>
            {isOpenFolderSelection && <StorageFolderSelection
                client={client}
                bucketname={bucketname || ''}
                isOpen={isOpenFolderSelection}
                onClose={() => setIsOpenFolderSelection(false)}
                prefix={[s3dirname(prefix)]}
                mode={'none'}
                initPath={s3dirname(prefix)}
                onAction={(p) => {
                    setPath(p);
                    setIsOpenFolderSelection(false);
                }}
            />}
            {success ?
                <div className="form-message _success">
                    <div className="form-message__icon" />
                    <h2 className="popup__heading form-message__heading">
                        Спасибо за&nbsp;ваши предложения
                    </h2>
                    <div className="form-message__copy">
                        Мы&nbsp;обязательно примем их&nbsp;к&nbsp;рассмотрению
                    </div>
                    <div className="form-message__ok">
                        <span className="btn" onClick={() => onClose()}>Хорошо</span>
                    </div>
                </div>
                :
                ((fail || !prefix)
                    ?
                    <div className="form-message _error">
                        <div className="form-message__icon"></div>
                        <h2 className="popup__heading form-message__heading">
                            {!prefix ?
                                'Отсутствуют медиа файлы'
                                :
                                'Что-то пошло не так'
                            }
                        </h2>
                        <div className="form-message__copy">
                            {fail}
                            {!prefix &&
                                <>Для транскодирования загрузите файлы контента</>
                            }
                        </div>
                        <div className="form-message__ok">
                            <span className="btn" onClick={() => onClose()}>Понятно</span>
                        </div>
                    </div>
                    :
                    <div className="transcode-order">
                        <div className="transcode-order__heading">Заказ транскодирования</div>
                        <Label><Trans>Profile</Trans></Label>
                        <Select value={profileId} options={availProfiles} onChange={(v) => setProfileId(v)} />
                        <div className="transcode-order__settings" style={{ maxWidth: 'max-content' }}>
                            <div className="transcode-order__settings-item">
                                Контейнер <strong>HLS</strong>
                            </div>
                            <div className="transcode-order__settings-sep"></div>
                            <div className="transcode-order__settings-item">
                                <Trans>Video codec</Trans> <strong>H.264</strong>
                            </div>
                            <div className="transcode-order__settings-sep"></div>
                            <div className="transcode-order__settings-item">
                                Аудиокодек <strong>AAC</strong>
                            </div>
                        </div>
                        <ul className="transcode-order__formats">
                            <li>416×234 · <strong>145</strong> kbps</li>
                            <li>640×360 · <strong>365</strong> kbps</li>
                            <li>768×432 · <strong>730</strong> kbps</li>
                            <li>1280×720 · <strong>3</strong> Mbps</li>
                            <li style={{ marginBottom: '6px' }}>1920×1080 · <strong>6</strong> Mbps</li>
                        </ul>
                        <Label><Trans>storage:PATH_TO_FILE</Trans>: <strong>{path || '/'}</strong></Label> 
                        <Button onClick={() => setIsOpenFolderSelection(true)}><Trans>Choose</Trans></Button>

                        <TextInput value={filename} onChange={(e) => setFilename(e.target.value)} label={t('Filename')} />

                        <div className="transcode-order__submit">
                            <span
                                className="btn"
                                onClick={() => {
                                    createTranscode({ profileId: profileId, mediaUrl: prefix }).unwrap().then(() => {
                                        onClose();
                                    }).catch(e => {
                                        setFail(JSON.stringify(e));
                                    })
                                }}
                            >
                                Подтвердить заказ
                            </span>
                        </div>
                    </div>
                )
            }
        </Modal>
    );
}


interface StorageActionsProps {
    selected: string[],
    onClean: () => void,
    readonly?: boolean
    base?: boolean
    forbidDelete?: boolean,
    onDownloadZip?: (v: string) => void
    onDownload?: (v: string[]) => void,
    onShare?: (v: string) => void
    onAccess?: (v: string) => void
    onRename?: (v: string) => void
    onCopy?: (v: string[]) => void
    onCopyInMy?: (v: string[]) => void
    onMove?: (v: string[]) => void
    onDelete?: (v: string[]) => void
    onUnzip?: (v: string) => void
    onZip?: (v: string[]) => void
}

function StorageActions({
    selected, readonly, base, forbidDelete, onClean,
    onAccess, onCopy, onCopyInMy, onDelete, onDownload, onMove, onShare, onRename, onUnzip, onZip, onDownloadZip,
}: StorageActionsProps) {
    const single = selected.length === 1;
    const isFolder = single && selected[0].endsWith('/');
    const haveFolder = selected.some((s) => s.endsWith('/'));
    const isZip = single && selected[0].endsWith('.zip');

    const [showTranscodeModal, setShowTranscodeModal] = useState(false);

    if (forbidDelete && isFolder && !onDownloadZip && !onCopyInMy) return null;

    return (
        <div className={`storage__file-actions ${selected.length > 1 ? '_multiple' : ''} _archive`}>
            <TranscodeModal
                client={new S3Client()}
                bucketname=""
                prefix={selected[0]}
                isOpen={showTranscodeModal}
                onClose={() => setShowTranscodeModal(false)}
            />

            {single && <div className="storage__file-actions-group _main">
                {false && <div className="storage__file-actions-item _download" onClick={() => { setShowTranscodeModal(true); }}>
                    <TransCode />
                    <span className="storage__file-actions-item-label">
                        <Trans>Transcode</Trans>
                    </span>
                </div>}
                {isFolder && onDownloadZip && <div className="storage__file-actions-item _download" onClick={() => { onDownloadZip(selected[0]); onClean(); }}>
                    <Download />
                    <span className="storage__file-actions-item-label">
                        <Trans>Download</Trans>
                    </span>
                </div>}
                {!isFolder && onDownload && <div className="storage__file-actions-item _download" onClick={() => { onDownload(selected); onClean(); }}>
                    <Download />
                    <span className="storage__file-actions-item-label">
                        <Trans>Download</Trans>
                    </span>
                </div>}
                {!(readonly || base) && <>
                    {onShare && <div className="storage__file-actions-item _share" onClick={() => { onShare(selected[0]); onClean(); }}>
                        <Share />
                        <span className="storage__file-actions-item-label">
                            <Trans>storage:SHARE</Trans>
                        </span>
                    </div>}
                    {onAccess && <div className="storage__file-actions-item _access" onClick={() => { onAccess(selected[0]); onClean(); }}>
                        <Access />
                        <span className="storage__file-actions-item-label">
                            <Trans>Access</Trans>
                        </span>
                    </div>}
                </>}
            </div>
            }
            <div className="storage__file-actions-group _storage">
                <div className="storage__file-actions-item _counter" onClick={() => onClean()}>
                    <span className="storage__file-actions-item-label">{selected.length}</span>
                </div>
                {!single && !haveFolder && onDownload && <div className="storage__file-actions-item _download" onClick={() => { onDownload(selected); onClean(); }}>
                    <Download />
                    <span className="storage__file-actions-item-label">
                        <Trans>Download</Trans>
                    </span>
                </div>}
                {onZip && (
                    <div className="storage__file-actions-item _unpack-save" onClick={() => { onZip(selected); onClean(); }}>
                        <Extract />
                        <span className="storage__file-actions-item-label">
                            <Trans>storage:ZIP</Trans>
                        </span>
                    </div>
                )}
                {isZip && onUnzip && (
                    <div className="storage__file-actions-item _unpack-save" onClick={() => { onUnzip(selected[0]); onClean(); }}>
                        <Extract />
                        <span className="storage__file-actions-item-label">
                            <Trans>storage:EXTRACT</Trans>
                        </span>
                    </div>
                )}
                {onCopyInMy && (
                    <div className="storage__file-actions-item _copy" onClick={() => { onCopyInMy(selected); onClean(); }}>
                        <Copy />
                        <span className="storage__file-actions-item-label">
                            <Trans>storage:COPY_TO_MY</Trans>
                        </span>
                    </div>
                )}
                {!(readonly || forbidDelete) && <>
                    {onCopy && <div className="storage__file-actions-item _copy" onClick={() => { onCopy(selected); onClean(); }}>
                        <Copy />
                        <span className="storage__file-actions-item-label">
                            <Trans>storage:COPY_TO</Trans>
                        </span>
                    </div>}
                    {onMove && <div className="storage__file-actions-item _move" onClick={() => { onMove && onMove(selected); onClean(); }}>
                        <Move />
                        <span className="storage__file-actions-item-label">
                            <Trans>storage:MOVE</Trans>
                        </span>
                    </div>}
                    {onRename && <div className="storage__file-actions-item _rename" onClick={() => { onRename(selected[0]); onClean(); }}>
                        <Rename />
                        <span className="storage__file-actions-item-label">
                            <Trans>storage:RENAME</Trans>
                        </span>
                    </div>}
                </>}
                {!forbidDelete && onDelete && <div className="storage__file-actions-item _remove" onClick={() => { onDelete(selected); onClean(); }}>
                    <Remove />
                    <span className="storage__file-actions-item-label">
                        <Trans>Delete</Trans>
                    </span>
                </div>}
                {!(readonly || forbidDelete) && <>
                    <div className="storage__file-actions-item _more">
                        <More />
                        <span className="storage__file-actions-item-label">
                            <Trans>storage:YET</Trans>
                        </span>
                        <div className="storage__file-actions-item-list">
                            {onCopy && <div className="storage__file-actions-item _copy" onClick={() => { onCopy(selected); onClean(); }}>
                                <Copy />
                                <span className="storage__file-actions-item-label">
                                    <Trans>storage:COPY_TO</Trans>
                                </span>
                            </div>}
                            {onMove && <div className="storage__file-actions-item _move" onClick={() => { onMove(selected); onClean(); }}>
                                <Move />
                                <span className="storage__file-actions-item-label">
                                    <Trans>storage:MOVE</Trans>
                                </span>
                            </div>}
                            {onRename && <div className="storage__file-actions-item _rename" onClick={() => { onRename(selected[0]); onClean(); }} >
                                <Rename />
                                <span className="storage__file-actions-item-label">
                                    <Trans>storage:RENAME</Trans>
                                </span>
                            </div>}
                        </div>
                    </div>
                </>}
                <div className="storage__file-actions-item _close" onClick={() => onClean()}>
                    <CloseIcon />
                    <span className="storage__file-actions-item-label">
                        <Trans>Close</Trans>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default StorageActions;
